import { h, Component } from 'preact';
import { Header } from '@cube/blocks';
import { FinanceSpinner } from '../glyphs';
import { getIncomeStatement } from '@os/cloudquote';
import { CurrencyIndicator } from '../currency-indicator';
import style from './style';
import { Text } from 'preact-i18n';

const INTL_NS = 'stock-data-table';
const INTL_NS_IS = 'incomeStatement';

import StockDataTable from './index';

export default class IncomeStatement extends Component {

	componentWillMount() {
		getIncomeStatement(this.props.symbol).then((data) => this.setState({ data }));
	}

	render({ timespan, ...props }, { data }) {
		let rows = data && data.rows;

		if (!rows || !rows.length) {
			return (
				<FinanceSpinner />
			);
		}

		data.rows.map( (row) => {
			let oi = data.columns.indexOf('Operating Income'),
				on = data.columns.indexOf('Other Non-Operating Items, Net');
			row.push(row[oi] + row[on]);
		});
		data.columns.push('Earnings Before Taxes');

		return (
			<div>
				<Header class={style.dataHeader}
					title={<Text id={`${INTL_NS}.${INTL_NS_IS}.incomeStatement`} />}
					secondary={<Text id={`${INTL_NS}.${INTL_NS_IS}.numInMs`} />}
				>
					<CurrencyIndicator symbol={props.symbol} />
				</Header>
				<StockDataTable
					timespan={timespan}
					data={data}
					title={<Text id={`${INTL_NS}.${INTL_NS_IS}.revenue`} />}
					showDates
					cols={[
						{
							name: 'Total Revenue',
							nameIntl: <Text id={`${INTL_NS}.${INTL_NS_IS}.totalRev`} />
						},
						{
							name: 'Cost of Revenue',
							nameIntl: <Text id={`${INTL_NS}.${INTL_NS_IS}.costOfRev`} />
						},
						{
							name: 'Other Revenue',
							nameIntl: <Text id={`${INTL_NS}.${INTL_NS_IS}.otherRev`} />
						},
						{
							name: 'Gross Profit',
							nameIntl: <Text id={`${INTL_NS}.${INTL_NS_IS}.grossProfit`} />,
							bold: true
						}
					]}
				/>
				<StockDataTable
					timespan={timespan}
					data={data}
					title={<Text id={`${INTL_NS}.${INTL_NS_IS}.opExpenses`} />}
					cols={[
						{
							name: 'Research and Development',
							nameIntl: <Text id={`${INTL_NS}.${INTL_NS_IS}.researchDev`} />
						},
						{
							name: 'SG&A',
							nameIntl: <Text id={`${INTL_NS}.${INTL_NS_IS}.sGA`} />
						},
						{
							name: 'Depreciation, Depletion, Amortization and Accretion',
							nameIntl: <Text id={`${INTL_NS}.${INTL_NS_IS}.depAmort`} />
						},
						{
							name: 'Other Operating Expense',
							nameIntl: <Text id={`${INTL_NS}.${INTL_NS_IS}.otherOpExpenses`} />
						},
						{
							name: 'Operating Expenses',
							nameIntl: <Text id={`${INTL_NS}.${INTL_NS_IS}.opExpenses`} />
						},
						{
							name: 'Operating Income',
							nameIntl: <Text id={`${INTL_NS}.${INTL_NS_IS}.opIncome`} />,
							bold: true
						}
					]}
				/>
				<StockDataTable
					timespan={timespan}
					data={data}
					title={<Text id={`${INTL_NS}.${INTL_NS_IS}.incContOp`} />}
					cols={[
						{
							name: 'Other Non-Operating Items, Net',
							nameIntl: <Text id={`${INTL_NS}.${INTL_NS_IS}.otherNonOp`} />
						},
						{
							name: 'Earnings Before Taxes',
							nameIntl: <Text id={`${INTL_NS}.${INTL_NS_IS}.earningsPreTax`} />
						},
						{
							name: 'Interest Expense, Non-Operating',
							nameIntl: <Text id={`${INTL_NS}.${INTL_NS_IS}.intExpNonOp`} />
						},
						{
							name: 'Income Before Taxes',
							nameIntl: <Text id={`${INTL_NS}.${INTL_NS_IS}.incPreTax`} />
						},
						{
							name: 'Income Taxes',
							nameIntl: <Text id={`${INTL_NS}.${INTL_NS_IS}.incTaxes`} />
						},
						{
							name: 'Net Income From Continuing Operations',
							nameIntl: <Text id={`${INTL_NS}.${INTL_NS_IS}.netIncContOp`} />,
							bold: true
						}
					]}
				/>
				<StockDataTable
					timespan={timespan}
					data={data}
					title={<Text id={`${INTL_NS}.${INTL_NS_IS}.nonRecurring`} />}
					cols={[
						{
							name: 'Noncontrolling Interest, Extraordinary Items and Discontinued Operations',
							nameIntl: <Text id={`${INTL_NS}.${INTL_NS_IS}.nonContIntEtc`} />
						}
					]}
				/>
				<StockDataTable
					timespan={timespan}
					data={data}
					title={<Text id={`${INTL_NS}.${INTL_NS_IS}.netIncome`} />}
					cols={[
						{
							name: 'Net Income',
							nameIntl: <Text id={`${INTL_NS}.${INTL_NS_IS}.netIncome`} />,
							bold: true
						}
					]}
				/>
			</div>
		);
	}
}
